import { AfterViewInit, Component, Injector, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppComponentBase } from '@shared/common/app-component-base';
import { CommonCacheServiceProxy, CompanyProfileServiceProxy, DropdownProjectListDto, GetAllProjectDto, ProfileServiceProxy, ProjectServiceProxy, ProjectType, ReportServiceServiceProxy, UserListDto, UserServiceProxy,GetAllProjectForListViewDto,ProjectTypeForListView, ProjectType5, ProjectRestorMessageDto } from '@shared/service-proxies/service-proxies';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreadcrumbItem, selectedProjectType } from '@app/shared/common/sub-header/sub-header.component';
import { HeaderTitle } from '@app/shared/common/header-title/header-title.model';
import { UsersDateFormatService } from '@shared/common/dateTimeFormat/date-format.service';
import { HeaderTitleService } from '@app/shared/common/header-title/header-title.service';
import { finalize } from 'rxjs/operators';
import { AppConsts } from '@shared/AppConsts';
import { AbpSessionService, MessageService } from 'abp-ng2-module';
import { ModalDeletePopupComponent } from '@app/shared/common/modal-popup/modal-delete-popup/modal-delete-popup.component';
import { custom } from 'devextreme/ui/dialog';
import { Workbook } from 'exceljs';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as fs from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ModalPopupComponent } from '@app/shared/common/modal-popup/modal-popup/modal-popup.component';
import { ProjectService } from './Services/project.service';
import * as xlsx from "xlsx-js-style";
import { ProjectDropServiceService } from '@app/shared/layout/themes/default/project-drop-service.service';
import { ProjectNameServiceService } from '@app/shared/layout/themes/default/project-name-service.service';
import { DefaultLayoutService } from '@app/shared/layout/themes/default/default-layout.service';
const FileSaver = require("file-saver");
import { DatePipe } from '@angular/common';
import { MonitoringService } from '@app/shared/common/telemetry-implementation/MonitoringService ';
import { DxDataGridComponent } from 'devextreme-angular';
import { TimesheetService } from '../time-sheet/services/timesheet.service';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';


@Component({
    selector: 'app-projects-new',
    templateUrl: './projects-new.component.html',
    styleUrls: ['./projects-new.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProjectsNewComponent extends AppComponentBase implements OnInit, AfterViewInit {
    pipe = new DatePipe('en-US');
    @ViewChild("appModaldeletePopup") appModaldeletePopup: ModalDeletePopupComponent;
    @ViewChild("appModalPopup") appModalPopup: ModalPopupComponent;
    @ViewChild("projectsTabs", { static: false }) projectsTabs: TabsetComponent;
    @ViewChild("appChangeRouteModalPopup") appChangeRouteModalPopup: ModalPopupComponent;
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
    @ViewChild('myDrop', { static: true }) myDrop: NgbDropdown;

    projectsData: any[] = [];
    projectsDataForListView: GetAllProjectDto[] = [];
    selectedProjects: GetAllProjectDto[];
    visible = true;
    isLoading = false;
    maxValue = 10;
    show: boolean = false;
    selectedProjectType = 'Active';
    filterText = '';
    data = [];
    head: any;
    dateFormat = this.l('dd/MM/yyyy');
    dateId: number;
    paginatorElem: any;
    date: any;
    projectSelectedType = 'Active';
    projectExcelDataArray: any;
    projectFilter: string[];
    assignedUserIdFilter: number[];
    assignedprojectIdFilter: number[];
    organizationUnitList: GetAllProjectDto[] = [];
    orgResult: GetAllProjectDto[] = [];
    filterOrganization: GetAllProjectDto[] = [];
    loadIndicatorVisible = true;
    checkBoxesMode: string;
    allMode: string;
    projectIdEdit: number;
    singleDeleteid: number;
    issingleDeleteid = false;
    selectedItemKeys: any[] = [];
    isDeletedHeaderFilter: any;
    editOption: number;
    isManager = false;
    isShown: boolean = true; // shown by default
    isShown_grid: boolean = false; // hidden by default
    isHideExport: boolean = false;
    projectType: ProjectType5 = ProjectType5.AllProjects;
    contentId: string;
    projectTypes: number;
    filterValue: any;

    deleteBunchFromAllProjectIds: number[] = [];
    isdeleteBunchFromAllProjectIds = false;
    deleteBunchFromArchiveProjectIds: number[] = [];
    isdeleteBunchFromArchiveProject = false;
    deleteSingleProjectFromArchivedProjectsId: number;
    isdeleteSingleProjectFromArchivedProjects = false;
    isHideNwPrj: boolean = false;
    IsProjectDataEmpty = false;
    editClicked = false;
    detailProjClicked = false;
    projectStatus = ['', 'New', 'Active', 'Completed', 'Closed'];
    actionsAllProject = [
        { id: 1, icon: 'la la-edit', text: 'Edit' },
        { id: 2, icon: 'la la-archive', text: 'Archive' },
        { id: 3, icon: 'la la-trash', text: 'Delete' }
    ];
    projectListUpdate: any[] = [];

    ProjectType = [
        { id: 1, name: this.l('Flat Rate Project') },
        { id: 2, name: this.l('Hourly Project') },
        { id: 3, name: this.l('Internal Project') },
    ];

    sectionToShowProjects = [{ id: 1, name: AppConsts.sectionNameForUserDisplayProject.allProject, desc: 'Active Projects' },
    { id: 2, name: AppConsts.sectionNameForUserDisplayProject.archiveProject, desc: 'Archived Projects' },
    { id: 3, name: AppConsts.sectionNameForUserDisplayProject.deleteProject, desc: 'Deleted Projects' }];

    selectedSectionToShowProjects = { name: AppConsts.sectionNameForUserDisplayProject.allProject, desc: 'Active' };
    projectArchiveAndDeleteStore: number[] = [];

    newProjTabs: number[] = [];
    projType: number;
    projEditId: number;
    loggedInUserRole: string;

    selectedUsersDrpDwn: UserListDto[] = sessionStorage.getItem('projectsUsersFilter')
        ? JSON.parse(sessionStorage.getItem('projectsUsersFilter')) : [];

    selectedProjectsDrpDwn: DropdownProjectListDto[] = sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')
        ? JSON.parse(sessionStorage.getItem('activitiesRealTimeTeamTrackingProjectFilter')) : [];

    dateTime = new Date();
    msg: string;
    projectDataForExport: any[] = [];
    showProjectExport: boolean = false;
    isArchive: boolean = false;
    isdeleted: boolean = false;
    restoreFromArchBunch: boolean = false;
    restoreFromDeletedProjectList: boolean = false;
    isRestoreButtonDisabled: boolean = false;
    isarchiveButtonDisabled: boolean = false;
    userIds: number;
    constructor(
        private _monitorService: MonitoringService,
        injector: Injector,
        private router: Router,
        private _ProjectNameServiceService: ProjectNameServiceService,
        private _projectServiceProxy: ProjectServiceProxy,
        private _projectDropService: ProjectDropServiceService,
        private _userServiceProxy: UserServiceProxy,
        private _companyProfileServiceProxy: CompanyProfileServiceProxy,
        private headerTitleService: HeaderTitleService,
        private _abpSessionService: AbpSessionService,
        private toastr: ToastrService,
        private _messageService: MessageService,
        private _usersDateFormatService: UsersDateFormatService,
        public projectService: ProjectService,
        private _profileService: ProfileServiceProxy,
        private _spinnerService: NgxSpinnerService,
        private _defaultLayoutService: DefaultLayoutService,
        private _activatedRoute: ActivatedRoute,
        private _commonCacheServiceProxy: CommonCacheServiceProxy,
        private _timesheetService: TimesheetService) {
        super(injector);
        this.checkBoxesMode = 'always';
        this.allMode = 'page';
        this.isDeletedHeaderFilter = [{
            text: this.l('Yes'),
            value: ['isDeleted', '==', true]
        }, {
            text: this.l('No'),
            value: ['isDeleted', '==', false]
        },];
    }

    getProjectResponse() {
        this._defaultLayoutService.showType.subscribe((res: any) => {
            this.selectedProjectTypeFunction(res);
        }
        )
    }

    ngOnInit(): void {
        this.msg = "userId = " + this._abpSessionService.userId + "tenantId =" + this._abpSessionService.tenantId;
        this._monitorService.logPageView("UI-ProjectNew");
        // abp.event.on('getProjectResponse', () => { this.getProjectResponse(); });
        this.assignedUserIdFilter = this.selectedUsersDrpDwn.map((r) => r.id);
        this.getDateFormate();
        this.projectTypes = ProjectType.AllProjects;
        this.getUserWiseOtherShowAndHidePermissions();
        let x = this. _activatedRoute.snapshot.queryParams.id;
        x = x ? Number(x) : 1;
        this.selectedProjectTypeFunction(x);
        this._defaultLayoutService.selectedTabForProject(x);

        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem('Projects  |'),
            //new BreadcrumbItem('All Projects')
        ]));
        this.getLoggedInUserDetails();
    }

    ngAfterViewInit() {
        let div = document.getElementById('dropMenu');
    }

    checkIfAddProjectTabOpen() {
        if (this.newProjTabs.length < 1) {
            return false;
        } else {
            return true;
        }
    }

    changeRoute: any;
    changeRouteResolve: any;
    changeRouteReject: any;
    async showChangeRouteModal() {
        var component = this;

        return new Promise<boolean>((resolve, reject) => {
            this.appChangeRouteModalPopup.show(2);
            this.projectsTabs.tabs[1].active = true;
            component.changeRouteResolve = resolve;
            component.changeRouteReject = reject;
        });
    }

    showVal(event: any) {
        this.selectedProjects = [];
        const ProjectData = this.selectedProjects.concat(event.selectedRowsData);
        this.selectedProjects = ProjectData;
        //console.log('Selected Timesheets : ',this.selectedTimesheets);
    }

    searchbtn($event) {
        this.show = !this.show;
        if (!this.show) this.dataGrid.instance.clearFilter();
    }


    onContentReady(e: any) {
        var noData
        let filterUsers = this.dataGrid.instance.getDataSource();
        let filteredData = filterUsers.items();
        if (filteredData.length <= 0) {
            this.showProjectExport = true;
        }
        else {
            this.showProjectExport = false;
        }
        setTimeout(() => {
            noData = document.querySelector(".dx-datagrid-nodata");
            if (noData) {
                noData.innerHTML = `
      <div class="d-flex flex-column justify-content-center align-items-center px-4 pt-4 h-lg-610px"
      *ngIf="primengTableHelper?.records && !primengTableHelper?.records?.length">

      <img *ngIf="!isMyTimesheet" src="assets/common/images/projects/EmptyProjects.svg"
          class="w-275px mb-3" />
      <h6 class="my-3 text-muted  text-center">${this.l('NoDataFound')}</h6>
      </div>
              `
            }
        })
    }


    changeRouteModalYes(event) {
        this.changeRouteResolve(true);
    }

    changeRouteModalCancel() {
        this.changeRouteResolve(false);
    }

    createProject(projectType: number) {
        //this.router.navigate(['/app/main/projects-new/add-new-project'], { queryParams: { projectType: projectType } });
        // this.projType = projectType
        // if (this.newProjTabs.length < 1) this.newProjTabs.push(1);
        // //this.projectsTabs.tabs[1].active = true;
        // setTimeout(() => {
        //   this.projectsTabs.tabs[1].active = true;
        // });

        //  this.projectType = 1
        this._monitorService.logEvent("createProject", { "createProject": "redirct to: app/main/projects-new/add-new-project" + this.msg + this.dateTime });
        this.projType = projectType
        this.router.navigate(['/app/main/projects-new/add-new-project'], { queryParams: { projectType: projectType } });

    }
    createProjectInternal(projectType: number) {
        this._monitorService.logEvent("createProject", { "createProject": "redirct to: app/main/projects-new/add-internal-project" + this.msg + this.dateTime.getDate() });
        this.projType = projectType
        this.router.navigate(['/app/main/projects-new/add-internal-project'], { queryParams: { projectType: projectType } });
    }

    closeTab(event?: Event) {
        this._monitorService.logTrace("UI-closeTab", { "CloseTab ": "closeTab By : " + this.msg + this.dateTime })
        if (event) event.stopPropagation();
        this.newProjTabs = [];
        this.projectsTabs.tabs[0].active = true;
        this.headerTitleService.setPageTitle(new HeaderTitle([
            new BreadcrumbItem('Project  |'),
            // new BreadcrumbItem('All Projects')
        ]));
       // this.getAllProjects();
        this.getAllProjectsForList();
        this.selectedProjectType = 'Active';
        if (this.detailProjClicked) this.router.navigate(['/app/main/projects-new/project-details'], { state: { ProjectId: this.projectIdEdit, option: Number(this.projectType) } });
        if (this.editClicked) this.router.navigate(['/app/main/projects-new/add-new-project'], { state: { ProjectId: this.projectIdEdit, option: this.editOption, projectType: this.projectType } });
    }
    modalCancle() {
        this.editClicked = false;
        this.detailProjClicked = false;
    }

    closeTabWithPopUp(event?: Event) {
        this.projectsTabs.tabs[1].active = true;
        this.appModalPopup.show(2);
    }
    //
    // Get Date Format and bind the date with UI
    //
    getDateFormate() {
        if (AppConsts.dateFormatId) {
            this.dateFormat = AppConsts.dateFormatList.find(r => r.id === AppConsts.dateFormatId).name;
            this.dateFormat = this.dateFormat.toUpperCase().replace('DD', 'dd').replace('YYYY', 'yyyy');
        }
    }

    getLoggedInUserDetails() {
        //this._profileService.myProfileInfo().subscribe(res => {
        //  this.loggedInUserRole = res.designation;
        //});

        let myprofileDetails = (localStorage.getItem('MyProfileDetails'));
        let myProfileUser = JSON.parse(myprofileDetails);
        this.loggedInUserRole = myProfileUser.designation;
    }

    //
    // Get Permission For Show And Hide From Compoany Profile But Not used Due to Userwise Permissions
    //
    getCaptureSettingForShowAndHidePermissions() {
        this._monitorService.logEvent("getCaptureSettingForShowAndHidePermissions", { "getCaptureSettingForShowAndHidePermissions": "getCaptureSettingForEditView: " + this.msg + this.dateTime });
        if (!AppConsts.getCaptureSettingForEditViewInstance) {
            this._companyProfileServiceProxy.getCaptureSettingForEditView(this._abpSessionService.tenantId).subscribe(x => {
                this.isHideNwPrj = x !== null || x != undefined ? x.isNwPrjCreate : false;
                AppConsts.getCaptureSettingForEditViewInstance = x;
            });
        } else { this.isHideNwPrj = AppConsts.getCaptureSettingForEditViewInstance !== null || AppConsts.getCaptureSettingForEditViewInstance != undefined ? AppConsts.getCaptureSettingForEditViewInstance.isNwPrjCreate : false; }
    }
    //
    // Get Permission For User Added in Manage User -> User -> Setting -> Other Setting
    //
    getUserWiseOtherShowAndHidePermissions() {
        this._monitorService.logEvent("getUserWiseOtherShowAndHidePermissions", { "getUserWiseOtherShowAndHidePermissions": "getUserTrackOtherSettingForEdit: " + this.msg + this.dateTime });

        this._commonCacheServiceProxy.getUserTrackOtherSettingForEdit(this._abpSessionService.tenantId, this._abpSessionService.userId).subscribe(x => {
            this.isHideNwPrj = x !== null || x != undefined ? x.isNwPrjCreate : false; AppConsts.userSettings = x;
            this.isHideExport = x !== null || x != undefined ? x.isExptSec : false;
        });
    }


    arrowStatus: string = 'la-angle-down';
    clikedOn(closed) {
        this.arrowStatus = !closed ? 'la-angle-down' : 'la-angle-up';
    }

    getHoursAndMin(timespan: string) {
        const lastIndex = timespan.lastIndexOf('.'); // "08:39:59.9999999" for this kind of string we are removing ".999999"
        if (lastIndex > 6) {
            timespan = timespan.substring(0, lastIndex);
        }
        let days = 0;
        if (!timespan) return '00h 00m';
        if (timespan.includes(".")) { days = parseInt(timespan.split(".")[0]) * 24; if (days) timespan = timespan.split(".")[1]; }
        let hours = days ? parseInt(timespan.split(":")[0]) + days : parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}:${min < 10 ? "0" + min : min} h`;
    }

    // getSelectedData(data) {
    //   this.projectsData = data.length === 0 ? this.masterListProjectsData: data;
    // }

    redirectToViewPage(id: number, projectTypeId: number) {
        /* if ((!this.isGranted('Pages.Projects.View')) || (!this.isGranted('Pages.Projects.CRUD')) ) {
             return;
         }*/
        if (this.projectType === ProjectType5.DeletedProjects) {
            //this._messageService.warn("Deleted Project details is not available");
            return;
        }
        this.projectIdEdit = id;
        if (this.projectsTabs.tabs.length > 1) {
            this.detailProjClicked = true;
            this.closeTabWithPopUp();
            return;
        }
        this.router.navigate(['/app/main/projects-new/project-details'], { state: { ProjectId: id, option: projectTypeId } });
    }
    emptystate = false;
    getAllProjects() {
        try {
            this.selectedProjects = [];

            this.isLoading = true;
            this.spinnerService.show();
            this.emptystate=false;
            this.addNewDisappear=false;
            this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, this.projectType,this.assignedprojectIdFilter, this.filterText, this.isManager).pipe(finalize(() => {
             this.isLoading = false;

            this.spinnerService.hide();
            this.spinnerService.hide();
           })).subscribe(res => {
               this.projectsDataForListView = [];
               this.projectDataForExport = [];
            //    res.map(res => { res.billedHours = this.getHoursAndMin(res.billedHours); });
                res.forEach(x => {
                    x.billedHours = this.getHoursAndMin(x.billedHours);
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                    }
                    x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
                    this.dataGrid?.instance?.clearFilter();
                    this.projectsDataForListView.push(x);
                    this.projectDataForExport.push(x);
                    this.projectListUpdate.push(x);
                });

                this.IsProjectDataEmpty = this.projectsDataForListView.length ? false : true;
                if (res.length == 0) {
                    //this.emptystate=true;
                }
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }
    getAllProjectsForList() {

        try {
            this.selectedProjects = [];

            this.isLoading = true;
            this.spinnerService.show();
            this.emptystate = false;
            this.addNewDisappear = false;

            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, ProjectTypeForListView.AllProjects, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;

                this.spinnerService.hide();
            })).subscribe(res => {
                this.projectsData = [];
                this.projectDataForExport = [];
                //    res.map(res => { res.billedHours = this.getHoursAndMin(res.billedHours); });
                res.forEach(x => {
                    x.billedHours = this.getHoursAndMin(x.billedHours);
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                    }
                    x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
                    this.dataGrid?.instance?.clearFilter();
                    this.projectsData.push(x);
                    this.projectDataForExport.push(x);
                    this.projectListUpdate.push(x);
                });

                this.IsProjectDataEmpty = this.projectsData.length ? false : true;
                if (res.length == 0) {
                    //this.emptystate=true;
                }
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    addNewDisappear = false;
    getAllArchiveProjects() {
        try {
            this._monitorService.logTrace("UI-getAllArchiveProjects", { "getAllArchiveProjects ": "getProjectsByUserIds: called " + this + this.dateTime })
            this.emptystate = false;
            this.addNewDisappear = false;
            this.selectedProjects = [];

            this.isLoading = true;
            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, ProjectTypeForListView.ArchivedProjects, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(res => {
                this.projectsData = [];
                this.projectDataForExport = [];
                // res.map(res => { res.billedHours = this.getHoursAndMin(res.billedHours); });
                res.forEach(x => {
                    x.billedHours = this.getHoursAndMin(x.billedHours);
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                    }
                    x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
                    this.dataGrid?.instance?.clearFilter();
                    this.projectsData.push(x);
                    this.projectDataForExport.push(x);
                    this.projectListUpdate.push(x);

                });
                this.IsProjectDataEmpty = this.projectsData.length ? false : true;
                if (res.length == 0) {
                    //this.emptystate=true;
                    this.addNewDisappear = true;
                }
            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }



    getAllDeletedProjects() {
        try {
            this._monitorService.logTrace("UI-getAllDeletedProjects", { "getAllDeletedProjects ": "getProjectsByUserIds:called " + this.msg + this.dateTime })
            this.emptystate = false;
            this.addNewDisappear = false;
            this.selectedProjects = [];
            this.isLoading = true;
            this._projectServiceProxy.getProjectsByUserIdForListView(this.assignedUserIdFilter, ProjectTypeForListView.DeletedProjects, undefined, this.filterText, this.isManager).pipe(finalize(() => {
                this.isLoading = false;
            })).subscribe(res => {
                this.projectsData = [];
                this.projectDataForExport = [];
                res.forEach(x => {
                    // x.billedHours = this.getHoursAndMin(x.billedHours);
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                    }
                    x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
                    this.dataGrid?.instance?.clearFilter();
                    this.projectsData.push(x);
                    this.projectDataForExport.push(x);
                    this.projectListUpdate.push(x);
                });
                this.IsProjectDataEmpty = this.projectsData.length ? false : true;
                if (res.length == 0) {
                    this.addNewDisappear = true;
                    //this.emptystate=true;
                }

            });
        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    archiveBunchFromAllProject() {
        let temp: number[] = [];
        this.isArchive = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"))
            this.isArchive = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._projectServiceProxy.archiveProjectByList(temp).subscribe(() => {
           // this.getAllProjects();
            this.getAllProjectsForList();
            this.toastr.success(this.l("ProjectArchivedsuccessfully"));
            this.isArchive = false;
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    restoreBunchFromArchiveProject() {
        let temp: number[] = [];
        this.restoreFromArchBunch = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"))
            this.restoreFromArchBunch = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._projectServiceProxy.unArchiveProjectByList(temp).subscribe((res:ProjectRestorMessageDto[]) => {
            this.getAllArchiveProjects();
            res.forEach(x => {
                if(x.isRestored){
                 this.toastr.success(this.l("ProjectsRestoredsuccessfully"));
                } else{
                   this.toastr.warning(
                  this.l("The") + " " + x.projectName + " " + this.l("project requires an extension of its end date.")
            );
                }
            })
           
            this.restoreFromArchBunch = false;
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    deleteBunchFromAllProject() {
        this.isdeleteBunchFromAllProjectIds = true;
        this.isdeleted = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"))
            this.isdeleted = true;
            return;
        }
        this.selectedProjects.forEach(x => {
            this.deleteBunchFromAllProjectIds.push(x.id);
        });
        this.appModaldeletePopup.show();

    }

    undeleteBunchFromDeletedProject(){
        let temp: number[] = [];
        this.restoreFromDeletedProjectList = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"))
            this.restoreFromDeletedProjectList = false;
            return;
        }
        this.selectedProjects.forEach(x => {
            temp.push(x.id);
        });
        this._monitorService.logEvent("undeleteBunchFromDeletedProject", { "undeleteBunchFromDeletedProject": "unDeleteProjectByList:called " + this.msg + this.dateTime });
        this._projectServiceProxy.unDeleteProjectByList(temp).subscribe(() => {
            this.getAllDeletedProjects();
            this.toastr.success(this.l("ProjectsRestoredsuccessfully"));
            this.restoreFromDeletedProjectList = false;
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    deleteBunchFromArchiveProject() {
        this._monitorService.logTrace("UI-deleteBunchFromArchiveProject", { "deleteBunchFromArchiveProject ": "start: " + this.msg + this.dateTime })
        //let temp: number[] = [];
        this.deleteBunchFromArchiveProjectIds = [];
        this.isdeleteBunchFromArchiveProject = true;
        if (this.selectedProjects.length === 0) {
            this._messageService.warn(this.l("PleaseSelectProjects"))
            return;
        }
        this.appModaldeletePopup.show();
        this.selectedProjects.forEach(x => {
            this.deleteBunchFromArchiveProjectIds.push(x.id);
        });

    }


    //Check modal click for single/multiple/from_active/from_archieved and makes API call
    onModalYesClick(id) {
        if (this.issingleDeleteid) {
            this._projectServiceProxy.updateStatusProjectDelete(this.singleDeleteid).subscribe(() => {
               // this.getAllProjects();
                this.isShown_grid ? this.getAllProjects(): this.getAllProjectsForList();
                this.issingleDeleteid = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }
        if (this.isdeleteBunchFromAllProjectIds) {
            this._projectServiceProxy.deleteProjectByList(this.deleteBunchFromAllProjectIds).subscribe(() => {
              //  this.getAllProjects();
                this.isShown_grid ? this.getAllProjects(): this.getAllProjectsForList();
                this.isdeleteBunchFromAllProjectIds = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }
        if (this.isdeleteBunchFromArchiveProject) {
            this._projectServiceProxy.deleteProjectByList(this.deleteBunchFromArchiveProjectIds).subscribe(() => {
                this.getAllArchiveProjects();
                this.isdeleteBunchFromArchiveProject = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }
        if (this.isdeleteSingleProjectFromArchivedProjects) {
            this._projectServiceProxy.updateStatusProjectDelete(this.deleteSingleProjectFromArchivedProjectsId).subscribe(() => {
                this.getAllArchiveProjects();
                this.isdeleteSingleProjectFromArchivedProjects = false;
                this.toastr.error(this.l("ProjectDeletedsuccessfully"));
                //this.notify.success("Deleted Successfully", "Deleted !!");
            });
        }
    }

    toggleShow() {
        if (this.isShown_grid) {
            this.isShown_grid = false;
            this.isShown = true;
            this.getAllProjectsForList()
        }
        else if (this.isShown) {
            this.isShown_grid = true;
            this.isShown = false;
            this.getAllProjects()
        }
    }

    // toggleShow_grid() {
    //   if(this.isShown){
    //     this.isShown_grid=true;
    //     this.isShown=false;
    //   }
    // }

    textForClass: string = 'la-angle-down';
    onOpenChange(data: boolean): void {
        this.textForClass = data ? 'la-angle-up' : 'la-angle-down';
    }

    //Project Type Selection Active/Archieved/Deleted
    selectedProjectTypeFunction(id: number) {
        if (id === 1) {
            this.projectType = ProjectType5.AllProjects;
            this.selectedProjectType = 'Active';
           // this.getAllProjects();
            this.getAllProjectsForList();
        } else if (id === 2) {
            this.projectType = ProjectType5.ArchivedProjects;
            this.selectedProjectType = 'Archived';
            this.getAllArchiveProjects();
        } else {
            this.projectType = ProjectType5.DeletedProjects;
            this.selectedProjectType = 'Deleted';
            this.getAllDeletedProjects();
        }
    }

    checkIfContains() {
        this.projectsData = this.projectListUpdate;
        let tempData1 = [];
        this.projectsData.forEach(x => {

            if (x.name.toLowerCase().includes(this.filterText.toLowerCase())) {
                tempData1.push(x);
            }

        });
        this.projectsData = [];
        this.projectsData = tempData1;
        if (this.filterText.length <= 0) {
            this.projectsData = this.projectListUpdate;
         }

    }


















    filterByNew() {
        this.projectsData = this.projectsData.sort((a, b) => new Date(b.startDate.toString()).getTime() - new Date(a.startDate.toString()).getTime());
    }

    filterByOld() {
        this.projectsData = this.projectsData.sort((a, b) => new Date(a.startDate.toString()).getTime() - new Date(b.startDate.toString()).getTime());
    }

    filterByProject(selectedProjects: DropdownProjectListDto[]) {
        this._monitorService.logEvent("filterByProject", { "filterByProject": "filter action on project: " + this.msg + this.dateTime });
        if (!selectedProjects) {
            this.assignedprojectIdFilter = undefined;
            sessionStorage.removeItem('projectsProjectsFilter');
        } else {
            if (Array.isArray(selectedProjects)) {
                this.assignedprojectIdFilter = selectedProjects?.map(r => r.id);
                this.selectedProjectsDrpDwn = selectedProjects;
                sessionStorage.setItem('projectsProjectsFilter', JSON.stringify(this.selectedProjectsDrpDwn));
            }
        }

        // let temp: number[] = [];
        // selectedProjects.forEach(x => {
        //   temp.push(x.id);
        //   // if (x.projectType === this.projectType) temp.push(x.id);
        // });

        if (this.assignedprojectIdFilter.length === 0 || this.assignedprojectIdFilter === undefined) {
            if (this.selectedProjectType === 'Active') {
             //   this.getAllProjects();
                this.getAllProjectsForList();
            } else if (this.selectedProjectType === 'Archived') {
                this.getAllArchiveProjects();
            } else {
                this.getAllDeletedProjects();
            }
        } else {
            let isdeleted = this.projectType === ProjectType5.DeletedProjects ? 1 : 0;
            this._projectServiceProxy.getProjectsByUserIds(this.assignedUserIdFilter, this.projectType, this.assignedprojectIdFilter, this.filterText, this.isManager).subscribe(res => {
                // this.projectsData = res;
                this.projectsData = [];
                res.forEach(x => {
                    if (x.projectImage === '') {
                        x.projectImage = 'assets/common/images/projects/default image for project -1.png';
                    }
                    x['ProgressPercentage'] = this.productivityBarCalculation(x.startDate as any, x.endDate as any);
                    this.projectsData.push(x);
                });
            });
        }
    }

    filterByUser(selectedUser: UserListDto[]) {
        this._monitorService.logEvent("filterByUser", { "filterByUser": "filterByUser: " + this.msg + this.dateTime });
        if (!selectedUser) {
            this.assignedUserIdFilter = undefined;
            sessionStorage.removeItem('projectsUsersFilter');
        } else {
            if (Array.isArray(selectedUser)) {
                this.assignedUserIdFilter = selectedUser?.map(r => r.id);
                this.selectedUsersDrpDwn = selectedUser;
                sessionStorage.setItem('projectsUsersFilter', JSON.stringify(this.selectedUsersDrpDwn));
            }

        }
        // this.assignedUserIdFilter = selectedUser?.map(r => r.id);
        if (this.selectedProjectType === 'Active') {
          //  this.getAllProjects();
            this.getAllProjectsForList();
        } else if (this.selectedProjectType === 'Archived') {
            this.getAllArchiveProjects();
        } else {
            this.getAllDeletedProjects();
        }
    }

    i: number = 0;
    showdropdown(id: any) {
        let div = document.getElementById(id);
        this.i = this.i + 1;
        if (this.i == 1) {
            div.style.display = 'none';
        }
        //div.style.display='none';
        if (div.style.display === 'none') {
            div.style.display = 'block';
        } else {
            div.style.display = 'none';
        }
        let x = document.getElementById('projectbtn');
        x.classList.toggle('up-arrow');
    }

    closeDropDownMenu(id) {
        let div = document.getElementById(id);
        div.style.display = 'none';
        let x = document.getElementById('projectbtn');
        x?.classList?.remove('up-arrow');
    }

    editSingleProjectFromAllProjects(id: number, projectTypeId: number) {
        this._monitorService.logEvent("editSingleProjectFromAllProjects", { "editSingleProjectFromAllProjects": "redirect to:app/main/projects-new/edit-project" + this.msg + this.dateTime });
        this.projectIdEdit = id;
        this.projectService.setProjectId(projectTypeId);
        this.editOption = 1;
        this.myDrop?.close();
        if (this.projectsTabs.tabs.length > 1) {
            this.editClicked = true;
            this.closeTabWithPopUp();
            return;
        }
        if (projectTypeId != 3) this.router.navigate(['/app/main/projects-new/edit-project', this.projectIdEdit]);
        else this.router.navigate(['/app/main/projects-new/edit-internal-project', this.projectIdEdit]);
        //this.router.navigate(['/app/main/projects-new/edit-project'], { state: { ProjectId: this.projectIdEdit, option: this.editOption, projectType:projectTypeId} });
        //this.router.navigate(['/app/main/projects-new/add-new-project']);{ state: { timesheetId: timesheetId }
    }

    editProjectEvent(container: any) {
        this.projectIdEdit = container.data.id;
        this.editOption = 1;
        this.router.navigate(['/app/main/projects-new/add-new-project'], { state: { ProjectId: this.projectIdEdit, option: this.editOption } });
    }


    deleteSingleProjectFromAllProjects(id: number, myDrop) {
        myDrop.close();
        this.singleDeleteid = id;
        this.issingleDeleteid = true;
        this.appModaldeletePopup.show();
    }


    unarchiveSingleProjectFromArchivedProjects(id: number) {
        // if(new Date(projectData.endDate.toString()) < new Date()){
        //   this.notify.warn("Project was over end date is passed", "Warning !");
        //   return;
        // }
        this._projectServiceProxy.updateStatusProjectUnArchive(id).subscribe((res:ProjectRestorMessageDto) => {
            this.getAllArchiveProjects();
                if(res.isRestored){
                this.toastr.success(this.l("ProjectRestoredsuccessfully"));
            } else{
                this.toastr.warning(
                    this.l("The") + " " + res.projectName + " " + this.l("project requires an extension of its end date.")
                );
            }
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    } updateStatusProjectArchive

    archiveSingleProjectFromActiveProjects(id: number, myDrop) {
        this._monitorService.logEvent("archiveSingleProjectFromActiveProjects", { "archiveSingleProjectFromActiveProjects": "updateStatusProjectArchive:called " + this.msg + this.dateTime.getDate() });
        this.myDrop?.close();
        this._projectServiceProxy.updateStatusProjectArchive(id).subscribe(() => {
         //   this.getAllProjects();
            this.getAllProjectsForList();
            this.toastr.success(this.l("ProjectArchivedsuccessfully"));
            //this.notify.success("Archived Successfully", "Archieved !!");
        });
    }

    deleteSingleProjectFromArchivedProjects(id: number, myDrop) {
        this.deleteSingleProjectFromArchivedProjectsId = id;
        this.isdeleteSingleProjectFromArchivedProjects = true;
        this.appModaldeletePopup.show();
        myDrop.close();

    }
    get filteredProjects(): any[] {
        return this.projectsDataForListView.filter((item) =>
          item.name.toLowerCase().includes(this.filterText.toLowerCase())
        );
      }

    restoreSingleProjectFromDeletedProjects(id: number) {
        this._monitorService.logEvent("restoreSingleProjectFromDeletedProjects", { "restoreSingleProjectFromDeletedProjects": "updateStatusProjectUnDelete: " + this + this.msg + this.dateTime });

        this._projectServiceProxy.updateStatusProjectUnDelete(id).subscribe(() => {
            this.getAllDeletedProjects();
            this.toastr.success(this.l("ProjectRestoredsuccessfully"));
            //this.notify.success("Restored Successfully", "Restored !!");
        });
    }

    onExporting() {
        this.exportProjectsToExcel();
        return;

    }

 //   getDateFormatExport() {
 //       let dateFormat = "dd/MM/yyyy"; // Default date format
 //       if (AppConsts.dateFormatId) {
 //           const selectedDateFormat = AppConsts.dateFormatList.find((r) => r.id === AppConsts.dateFormatId);
 //           if (selectedDateFormat) {
 //               dateFormat = selectedDateFormat.name;
 //           }
 //       }
 //       return dateFormat;
 //   }

	//formatDateString(dateString, dateFormat) {
 //       let formattedDate = new Date(dateString).toLocaleDateString(undefined, {
 //           year: 'numeric',
 //           month: '2-digit',
 //           day: '2-digit',
 //       });

 //       if (dateFormat === "DD/MM/YYYY") {
 //           formattedDate = formattedDate.replace(/\//g, "-");
 //       } else if (dateFormat === "MM/DD/YYYY") {
 //           // Modify the format as needed
 //       } else if (dateFormat === "YYYY/DD/MM") {
 //           // Modify the format as needed
 //       }

 //       return formattedDate;
 //   }


 //Date Format Check

    changeDateFormatAsCompanyProfile(dateVal) {
        let formattedDate;

        if (this.dateFormat == 'dd/MM/yyyy') {
            formattedDate = moment(new Date(dateVal.toString())).format("DD MMM YYYY")
        }
        else if (this.dateFormat == 'MM/dd/yyyy') {
            formattedDate = moment(new Date(dateVal.toString())).format("MMM DD YYYY")

        }
        else {
            formattedDate = moment(new Date(dateVal.toString())).format("YYYY DD MMM")

        }
        let formattedCreationTime = new Date(formattedDate as any);
        return formattedCreationTime;
    }

    //Export Project Data to Excel
    exportProjectsToExcel(selectedItems = []) {
        try {
            this.dataGrid.instance.getDataSource()?.store()
            .load({ filter: this.dataGrid.instance.getCombinedFilter(true), sort: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.sort, group: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.group })
            .then((filteredData: any) => {
                this._monitorService.logTrace("UI-exportProjectsToExcel", { "exportProjectsToExcel ": "export Project In Excel: " + this + this.msg + this.dateTime })
                let projectStatusname;
                let projectBillingStatusType;

                const workbook: xlsx.WorkBook = xlsx.utils.book_new();

                let saveFiletitle = '';
                    if (this.selectedProjectType === 'Active') {
                        saveFiletitle = "Active";
                    } else if (this.selectedProjectType === 'Archived') {
                        saveFiletitle = "Archived";
                    } else {
                        saveFiletitle = "Deleted";
                    }
                const worksheet: xlsx.WorkSheet = xlsx.utils.aoa_to_sheet([]);
                xlsx.utils.sheet_add_aoa(worksheet, [[saveFiletitle + " Projects List"]], { origin: "A1" });

                xlsx.utils.sheet_add_aoa(
                    worksheet,
                    [['Project Name','Program Manager','Project Manager', 'Client Name','Client Contact','Project Status','Billing Status', 'Billed Hour','Completion Percentage', 'Start Date', 'End Date','Description'
                       ]],
                    {
                        origin: "A2",
                    }
                );


                // let filterUsers = this.dataGrid.instance.getDataSource();
                // let filteredData = filterUsers.items();
                this.projectsData = [];
                selectedItems.length == 0 ? this.projectsData = filteredData :  this.projectsData = selectedItems;
                if (this.projectsData.length > 0) {
                    let data = this.projectsData.map((x) => {
                        if (x.projectStatus == 1) {
                            projectStatusname = 'New';
                        }
                        else if (x.projectStatus == 2) {
                            projectStatusname = 'Active';
                        }
                        else if (x.projectStatus == 3) {
                            projectStatusname = 'Completed';
                        }
                        else if (x.projectStatus == 4) {
                            projectStatusname = 'Closed';
                        }

                        if(x.projectBillingType == 1){
                            projectBillingStatusType = 'Billable';
                         }
                         else if(x.projectBillingType == 2){
                            projectBillingStatusType = 'Non-Billable';
                         }


                        let formattedstartDateStr = this.changeDateFormatAsCompanyProfile(x.startDate);
                        let formattedendDateStr = this.changeDateFormatAsCompanyProfile(x.endDate);
                        //console.log(formattedstartDateStr, 'Start');
                        //console.log(formattedendDateStr, 'End');


                        let arr = [x.name, x.assignedProgramManagerName ? x.assignedProgramManagerName : '-', x.projectManagers? x.projectManagers : '-', x.clientName ? x.clientName : '-', x.clientContact ? x.clientContact : '-', projectStatusname, projectBillingStatusType, (this._timesheetService.getFormattedHoursAbove24Hrs(x.billedHours)), x['ProgressPercentage'], formattedstartDateStr, formattedendDateStr, x.description ? x.description : '-'];
                        return arr;
                    });
                    if (this.loggedInUserRole == "Employee,") {
                        xlsx.utils.sheet_add_aoa(
                            worksheet,
                            [['Project Name', 'Client Name', 'Start Date', 'End Date', 'Billed Hour',
                                'Status']],
                            {
                                origin: "A2",
                            }
                        );

                        let filterUsers = this.dataGrid.instance.getDataSource();
                        let filteredData = filterUsers.items();
                        this.projectsData = [];
                        this.projectsData = filteredData;
                        data = this.projectsData.map((x) => {
                            if (x.projectStatus == 1) {
                                projectStatusname = 'New';
                            }
                            else if (x.projectStatus == 2) {
                                projectStatusname = 'Active';
                            }
                            else if (x.projectStatus == 3) {
                                projectStatusname = 'Completed';
                            }
                            else if (x.projectStatus == 4) {
                                projectStatusname = 'Closed';
                            }


                            let formattedstartDateStr = this.changeDateFormatAsCompanyProfile(x.startDate);
                            let formattedendDateStr = this.changeDateFormatAsCompanyProfile(x.endDate);
                            let arr = [x.name, x.clientName ? x.clientName : '-', formattedstartDateStr, formattedendDateStr, (x.billedHours), projectStatusname];


                            return arr;
                        });
                    }
                    xlsx.utils.sheet_add_aoa(worksheet, data, { origin: "A3" });
                    worksheet["!cols"] = [
                        { width: 25 },
                        { width: 25 },
                        { width: 25 },
                        { width: 20 },
                        { width: 20 },
                        { width: 15 },
                        { width: 15 },
                        { width: 15 },
                        { width: 21 },
                        { width: 15 },
                        { width: 15 },
                        { width: 25 }

                    ];
                    for (let i in worksheet) {
                        if (typeof worksheet[i] != "object") continue;
                        let cell = xlsx.utils.decode_cell(i);
                        worksheet[i].s = {
                            font: {
                                name: "Calibri",
                                sz: 11,
                                color: { rgb: "000000" },
                            },
                            border: {
                                top: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                bottom: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                left: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                                right: {
                                    style: "thin",
                                    color: { rgb: "000000" },
                                },
                            },
                        };

                        if (cell.r == 1) {
                            worksheet[i].s.font.bold = true;
                            worksheet[i].s.fill = {
                                patternType: "solid",
                                fgColor: { rgb: "DDDDDD" },
                            };
                        }
                        if (cell.r == 0) {
                            worksheet[i].s.font.bold = true;
                            worksheet[i].s.font.u = true;
                            worksheet[i].s.font.sz = 12;
                            worksheet[i].s.fill = {
                                patternType: "solid",
                                fgColor: { rgb: "FFFFFF" },

                            };
                            worksheet[i].s.alignment = {
                                vertical: "center",
                                horizontal: "center",
                                wrapText: '1',
                            }
                        }
                    }
                    for (var i in worksheet) {
                        if (typeof worksheet[i] != 'object') continue;
                        let cell = xlsx.utils.decode_cell(i);
                        if (cell.c == 4) {
                            worksheet[i].z = '0.00';
                        }
                    /*    if (cell.c == 1 || cell.c == 3) {
                            worksheet[i].z = this.dateFormat;
                        }*/
                    }
                    // Merge and center cells A1 to F1
worksheet["!merges"] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 11 } }];

                    xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet 1");
                    const excelBuffer: any = xlsx.write(workbook, {
                        bookType: "xlsx",
                        type: "array",
                    });

                    let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    let EXCEL_EXTENSION = ".xlsx";
                    const data2: Blob = new Blob([excelBuffer], {
                        type: EXCEL_TYPE,
                    });
                    let saveFileName = '';
                    if (this.selectedProjectType === 'Active') {
                        saveFileName = "Active";
                    } else if (this.selectedProjectType === 'Archived') {
                        saveFileName = "Archived";
                    } else {
                        saveFileName = "Deleted";
                    }

                        this.projectsData = this.projectDataForExport;

                    FileSaver.saveAs(data2, saveFileName + " Projects List");
                }
                else {

                        this.projectsData = this.projectDataForExport;

                }
            });

        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }
    }

    //Export Project Data to Pdf
    exportGridPdf(selectedItems = []) {
        try {
            this.dataGrid.instance.getDataSource()?.store()
            .load({ filter: this.dataGrid.instance.getCombinedFilter(true), sort: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.sort, group: this.dataGrid?.instance?.getDataSource()?.loadOptions()?.group })
            .then((filteredData: any) => {
                this._monitorService.logTrace("UI-exportGridPdf", { "exportGridPdf ": "PDF export: " + this + this.msg + this.dateTime });
                let projectStatusname;
                let projectBillingStatusType;

                    this.head = [['Project Name','Program Manager','Project Manager', 'Client Name','Client Contact','Project Status','Billing Status','Billed Hour','Completion Percentage', 'Start Date', 'End Date','Description']];

                this.projectExcelDataArray = [];
                // let filterUsers = this.dataGrid.instance.getDataSource();
                // let filteredData = filterUsers.items();
                this.projectsData = [];
                selectedItems.length == 0 ? this.projectsData = filteredData : this.projectsData = selectedItems;

                if (this.projectsData.length > 0) {
                    this.projectsData.forEach(x => {

                        if (x.endDate) {
                            this.date = (x.endDate).toLocaleString();
                        }
                        if (x.projectStatus == 1) {
                            projectStatusname = 'New';
                        }
                        else if (x.projectStatus == 2) {
                            projectStatusname = 'Active';
                        }
                        else if (x.projectStatus == 3) {
                            projectStatusname = 'Completed';
                        }
                        else if (x.projectStatus == 4) {
                            projectStatusname = 'Closed';
                        }

                         if(x.projectBillingType == 1){
                            projectBillingStatusType = 'Billable';
                         }
                         else if(x.projectBillingType == 2){
                            projectBillingStatusType = 'Non-Billable';
                         }



                        this.data = [x.name,x.assignedProgramManagerName ? x.assignedProgramManagerName :'-', x.projectManagers, x.clientName, x.clientContact ? x.clientContact : '-', projectStatusname, projectBillingStatusType,(x.billedHours), x['ProgressPercentage'] ,(x.startDate).toFormat('dd/MM/yyyy').toLocaleString(), (x.endDate).toFormat('dd/MM/yyyy').toLocaleString(), x.description ? x.description : '-'];

                        this.projectExcelDataArray.push(this.data);
                    });

                    if (this.loggedInUserRole == "Employee,") {
                        this.head = [['Project Name', 'Client Name', 'Hour Logged', 'Billed Hour',
                            'End Date',]];
                        this.projectExcelDataArray = [];
                        this.projectsData.forEach(x => {
                            if (x.endDate) this.date = (x.endDate).toLocaleString();


                            this.data = [x.name, x.clientName, , this.date];
                            this.projectExcelDataArray.push(this.data);
                        });
                    }
                    let saveFileName = '';
                    let fileTitle = '';
                    if (this.selectedProjectType === 'Active') {
                        saveFileName = "Active";
                        fileTitle = "Active";
                    } else if (this.selectedProjectType === 'Archived') {
                        saveFileName = "Archived";
                        fileTitle = "Archived";
                    } else {
                        saveFileName = "Deleted";
                        fileTitle = "Deleted";
                    }


                    const doc = new jsPDF("l", "pt");

                    doc.setFontSize(14);
                    doc.text(fileTitle + ' Project List', 15, 10);
                    doc.setFontSize(11);
                    doc.setTextColor(100);
                    (doc as any).autoTable({
                        head: this.head,
                        body: this.projectExcelDataArray,
                        theme: 'striped',
                        tableLineColor: [189, 195, 199],
                        startY: 20,
                        margin: {
                            top: 15
                        },
                        didDrawCell: data => {
                            //console.log(data.column.index);
                        }
                    });
                    //doc.output('dataurlnewwindow');

                        this.projectsData = this.projectDataForExport;
                    doc.save(saveFileName + ' Projects List.pdf');
                }
                else {
                        this.projectsData = this.projectDataForExport;
                }
            });

        }
        catch (ex: any) {
            this._monitorService.logException(ex, 2);
        }

    }

    //project progressbar calculation
    productivityBarCalculation(startD: Date, endD: Date) {
        this._monitorService.logEvent("productivityBarCalculation", { "productivityBarCalculation": "productivityBarCalculation action: " + this.msg + this.dateTime });
        if (!startD || !endD) return 0;
        let progressBar = 0;
        var startDate = new Date(startD.toString());
        var endDate = new Date(endD.toString());
        const PresentDay = new Date();
        if ((startDate > endDate) || (startDate > PresentDay)) {
            progressBar = 0;
        } else if (PresentDay > endDate) {
            progressBar = 100;
        } else {
            progressBar = (PresentDay.getTime() - startDate.getTime()) * 100 / (endDate.getTime() - startDate.getTime());
        }
        progressBar = Math.floor(progressBar);

        return progressBar;
    }


    DisableTooltip(name: string, num: number) {
        return name?.length > num ? false : true;
    }

    displayOnDropdown(): string {

        if (this.contentId == 'Active') {

            return "Active";
        } else if (this.contentId == 'Archived') {

            return "Archive";
        } else
            return "Deleted";
    }

    openSelectedTab(value: number) {
        if (value === 1) {
            this.projectTypes = ProjectType.AllProjects;
            this.projectSelectedType = 'Active';
        }
        if (value === 2) {
            this.projectTypes = ProjectType.ArchivedProjects;
            this.projectSelectedType = 'Archived';
        }
        if (value === 3) {
            this.projectTypes = ProjectType.DeletedProjects;
            this.projectSelectedType = 'Deleted';
        }


        //  {
        //     this.getAllProjects();
        //   }
    }

    //   getProjectResponse(){
    //     this._projectDropService.showProjectType.subscribe((res:any)=>{
    // this.openSelectedTab(res);
    //     })
    //   }


    onClickCard(event: string) {

        this._ProjectNameServiceService.createCard(event);

    }
    getHours(timespan: string) {
        if (!timespan) return '00h 00m';
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${hours < 10 ? "0" + hours : hours}`;
    }
    getMins(timespan: string) {
        if (!timespan) return '00h 00m';
        let hours = parseInt(timespan.split(":")[0]);
        let min = parseInt(timespan.split(":")[1]);
        return `${min < 10 ? "0" + min : min}`;
    }
    calculateFilterExpression(value, selectedFilterOperations, target) {
        const column = this as any;
        if (arguments[0].includes('m')) { arguments[0] = arguments[0].replace('m', '') }
        if (arguments[0].includes('h ')) { arguments[0] = arguments[0].replace('h ', ':') }
        if (arguments[0].includes('h')) { arguments[0] = arguments[0].replace('h', ':') }
        return column.defaultCalculateFilterExpression.apply(this, arguments);
    }
    dateFormatDX = (arg) => (
        this.pipe.transform(arg, this.dateFormat)
    );
    onExportButtonChange(val: any) {
        switch (val) {
            case 1: // Export all data to PDF
                this.exportGridPdf();
                break;
            case 2: // Export selected data to PDF
                this.exportGridPdf(this.selectedProjects);
                break;
            case 3: // Export all data to Excel
                this.exportProjectsToExcel();
                break;
            case 4: // Export selected data to Excel
                this.exportProjectsToExcel(this.selectedProjects);
                break;
        }
    }

}
